<template>
  <div v-if="visible" class="lightbox-overlay">
    <VueEasyLightbox
      :visible="visible"
      :imgs="imgs"
      :index="index"
      :loop="true"
      :move-disabled="true"
   :rotate-disabled="true"
      @hide="onHide"
      @show="onLightboxShow"
    />
  </div>
</template>

<script setup>
import { nextTick } from 'vue';
import VueEasyLightbox from 'vue-easy-lightbox';

const props = defineProps({
  data: {
    type: Array,
    required: true
  },
  image_value: {
    type: String,
    required: true
  }
});

const visible = ref(false);
const index = ref(0);
const imgs = ref([]);

const updateLightbox = () => {
  imgs.value = props.data.map(item => item.url);
  
  const imageIndex = props.data.findIndex(item => item.url === props.image_value);
  if (imageIndex !== -1) {
    index.value = imageIndex;
  }
};

const onHide = () => {
  visible.value = false;
  
  nextTick(() => {
    imgs.value = [];  
    index.value = 0;  
  });
};

const onLightboxShow = () => {
  console.log('Lightbox shown');
};

defineExpose({
  show: (indexValue) => {
    index.value = indexValue;
    visible.value = true;

    updateLightbox();
  }
});

watch(() => props.image_value, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    updateLightbox();
  }
});
</script>
